import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { 
  FiUploadCloud, FiFile, FiDownload, FiCheck, FiAlertTriangle,FiCreditCard,FiFileText,FiDollarSign,FiAward,FiTrendingUp,FiBriefcase,FiZap,FiGlobe
} from 'react-icons/fi';
import { TbCurrencyRupee } from 'react-icons/tb';
import Flag from 'react-world-flags';
import logo from '../image/SMAC-X LOGO.jpg';
import VerificationDashboard from './VerificationDashboard';
import PANVerificationDashboard from './PANVerificationDashboard';
import CINVerificationDashboard from './CINVerificationDashboard';
import BankVerificationDashboard from './BankVerificationDashboard';
import MSMEVerificationDashboard from './MSMEVerificationDashboard';

const DocumentExtractor = () => {
  const { token, user, logout } = useAuth();
  const [activeCountry, setActiveCountry] = useState('india');
  const [activeTab, setActiveTab] = useState('pan');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editableData, setEditableData] = useState({});

  const countries = {
    india: {
      name: 'India',
      flag: <Flag code="IN" className="w-4 h-3" />,
      documents: {
        pan: { name: 'PAN Card', fields: ['pan_number', 'name', /*'father_name',*/ 'date_of_birth'], icon: FiCreditCard, color: 'bg-yellow-500 text-white' },
        gst: { name: 'GST Certificate', fields: ['gstin', 'business_name', 'registration_date', 'business_type', 'address'], icon: TbCurrencyRupee, color: 'bg-yellow-500 text-white' },
        cheque: { name: 'Cancelled Cheque', fields: ['account_holder', 'account_number', 'ifsc_code', 'bank_name', 'micr_code'], icon: FiFileText, color: 'bg-yellow-500 text-white' },
        msme: { name: 'MSME Certificate', fields: ['registration_number', 'business_name', 'enterprise_type', 'registration_date', 'incorporation_date', 'flat_no', 'building', 'village', 'block', 'road', 'city', 'state', 'district', 'mobile', 'email'], icon: FiAward, color: 'bg-yellow-500 text-white' },
        startup: { name: 'Startup Registration', fields: ['certificate_number', 'entity_name', 'incorporation_date', 'DATE OF ISSUE', 'validity_date'], icon: FiTrendingUp, color: 'bg-yellow-500 text-white' },
        coi: { name: 'Certificate of Incorporation', fields: ['name_of_entity', 'cin', 'pan', 'tan', 'incorporation_date'], icon: FiBriefcase, color: 'bg-yellow-500 text-white' }
      }
    },
    kenya: {
      name: 'Kenya',
      flag: <Flag code="KE" className="w-4 h-3" />,
      documents: {
        incorporation_cert: { name: 'Certificate of Incorporation', fields: ['certificate_number', 'company_name', 'incorporation_date', 'company_type', 'act_reference'], icon: FiBriefcase, color: 'bg-green-500 text-white' },
        business_registration: { name: 'Business Registration Certificate', fields: ['business_number', 'business_name', 'owner_name', 'address', 'registration_date', 'po_box', 'district'], icon: FiFileText, color: 'bg-green-500 text-white' },
        cr12: { name: 'Current CR12', fields: ['company_name', 'registration_number', 'registration_date', 'registered_office', 'postal_address'], icon: FiFileText, color: 'bg-green-500 text-white' },
        pin_certificate: { name: 'PIN Certificate / Current TCC', fields: ['company_name', 'pin_number', 'certificate_number', 'certificate_date', 'issue_date', 'validity_date', 'address', 'po_box', 'postal_code'], icon: FiDollarSign, color: 'bg-green-500 text-white' }
      }
    },
    nigeria: {
      name: 'Nigeria',
      flag: <Flag code="NG" className="w-4 h-3" />,
      documents: {
        incorporation_cert: { name: 'Incorporation Certificate', fields: ['company_name', 'rc_number', 'incorporation_date', 'company_type'], icon: FiBriefcase, color: 'bg-green-600 text-white' },
        tax_registration: { name: 'Tax Registration Certificate', fields: ['tcc_number', 'company_name', 'rc_number', 'tin_number', 'firs_id', 'incorporation_date', 'business_address', 'business_status', 'expiry_date'], icon: FiDollarSign, color: 'bg-green-600 text-white' }
      }
    },
    china: {
      name: 'China',
      flag: <Flag code="CN" className="w-4 h-3" />,
      documents: {
        business_license: { name: 'Business License', fields: ['company_name', 'registration_number', 'legal_representative', 'business_scope'], icon: FiBriefcase, color: 'bg-red-500 text-white' },
        incorporation_cert: { name: 'Incorporation Certificate', fields: ['company_name', 'registration_number', 'incorporation_date', 'registered_capital'], icon: FiBriefcase, color: 'bg-red-500 text-white' }
      }
    }
  };

  const currentDocuments = countries[activeCountry]?.documents || {};

  const handleCountryChange = (country) => {
    setActiveCountry(country);
    const firstDoc = Object.keys(countries[country].documents)[0];
    setActiveTab(firstDoc);
    setFile(null);
    setPreview(null);
    setResult(null);
    setEditableData({});
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      if (selectedFile.type === 'application/pdf') {
        setPreview(URL.createObjectURL(selectedFile));
      } else {
        const reader = new FileReader();
        reader.onload = (e) => setPreview(e.target.result);
        reader.readAsDataURL(selectedFile);
      }
      setResult(null);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
      if (droppedFile.type === 'application/pdf') {
        setPreview(URL.createObjectURL(droppedFile));
      } else {
        const reader = new FileReader();
        reader.onload = (e) => setPreview(e.target.result);
        reader.readAsDataURL(droppedFile);
      }
      setResult(null);
    }
  };

  const extractData = async () => {
    if (!file) return;
    
    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      // Use new country-based API endpoint
      const response = await axios.post(`${apiUrl}/extract/${activeCountry}/${activeTab}`, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        }
      });
      setResult(response.data);
      setEditableData(response.data.extracted_data || {});
    } catch (error) {
      console.error('Extraction error:', error);
      setResult({ error: 'Failed to extract data' });
    } finally {
      setLoading(false);
    }
  };

  const handleFieldEdit = (field, value) => {
    setEditableData(prev => ({ ...prev, [field]: value }));
  };

  const exportJSON = () => {
    const dataStr = JSON.stringify(editableData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${activeTab}_data.json`;
    link.click();
  };

  const verifyGSTData = async (extractedData) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.post(`${apiUrl}/verify/gst`, {
      extracted_data: extractedData
    }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  };

  const verifyPANData = async (extractedData) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.post(`${apiUrl}/verify/pan`, {
      extracted_data: extractedData
    }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  };

  const verifyCINData = async (extractedData) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.post(`${apiUrl}/verify/surepass/cin`, {
      extracted_data: extractedData
    }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  };

  const verifyBankData = async (extractedData) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.post(`${apiUrl}/verify/surepass/bank`, {
      extracted_data: extractedData
    }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  };

  const verifyMSMEData = async (extractedData) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.post(`${apiUrl}/verify/surepass/msme`, {
      extracted_data: extractedData
    }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  };



  const exportTXT = () => {
    const getFieldLabel = (field) => {
      const labels = {
        'father_name': 'FATHER NAME',
        'date_of_birth': 'DATE OF BIRTH',
        'registration_number': 'REGISTRATION NUMBER',
        'business_name': 'BUSINESS NAME',
        'enterprise_type': 'TYPE OF ENTERPRISE',
        'registration_date': activeTab === 'msme' ? 'DATE OF UDYAM REGISTRATION' : 'DATE OF REGISTRATION',
        'incorporation_date': 'DATE OF INCORPORATION',
        'flat_no': 'FLAT/DOOR/BLOCK NO.',
        'building': 'NAME OF BUILDING',
        'village': 'VILLAGE/TOWN',
        'block': 'BLOCK',
        'road': 'ROAD STREET LANE',
        'mobile': 'MOBILE',
        'email': 'EMAIL',
        'company_name': 'COMPANY NAME',
        'rc_number': 'RC NUMBER',
        'tin_number': 'TIN NUMBER',
        'pin_number': 'PIN NUMBER',
        'legal_representative': 'LEGAL REPRESENTATIVE',
        'business_scope': 'BUSINESS SCOPE',
        'registered_capital': 'REGISTERED CAPITAL',
        'vendor_name': 'VENDOR NAME',
        'vendor_type': 'VENDOR TYPE',
        'vendor_category': 'VENDOR CATEGORY',
        'tax_office': 'TAX OFFICE',
        'compliance_period': 'COMPLIANCE PERIOD',
        'directors': 'DIRECTORS',
        'share_capital': 'SHARE CAPITAL',
        'issue_date': 'ISSUE DATE'
      };
      return labels[field] || field.replace(/_/g, ' ').toUpperCase();
    };

    let txtContent = `${currentDocuments[activeTab]?.name.toUpperCase()} - EXTRACTED DATA\n`;
    txtContent += '='.repeat(50) + '\n\n';
    
    currentDocuments[activeTab]?.fields.forEach(field => {
      const label = getFieldLabel(field);
      const value = editableData[field] || '';
      txtContent += `${label}: ${value}\n`;
    });
    
    const dataBlob = new Blob([txtContent], { type: 'text/plain' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${activeTab}_data.txt`;
    link.click();
  };

  return (
    <div className="min-h-screen bg-[#f4f7fa] flex flex-col">
      {/* Header */}
      <header className="border-b border-[#e1e8ed] shadow-sm flex">
        <div className="w-56 bg-white px-6 py-3 flex items-center">
          <img
            src={logo}
            alt="SMAC-X Logo"
            className="w-24 cursor-pointer"
            onClick={() => window.location.reload()}
          />
        </div>
        <div className="flex-1 bg-[#f6cc06] px-6 py-3 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-[#434242]">AI Document Processor - Smart Data Extractor</h1>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-[#434242]">
              {user?.email} ({user?.role})
            </span>
            <button
              onClick={logout}
              className="text-sm text-red-700 hover:text-red-900 font-medium"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex">
        {/* Sidebar */}
        <aside className="w-56 bg-[#434242] border-r border-[#5a5a5a] p-3 shadow-sm">
          {/* Country Selection */}
          <div className="mb-4">
            <h1 className="text-sm font-semibold text-white mb-2 flex items-center gap-2">
              <FiGlobe className="w-4 h-4" />
              Countries
            </h1>
            <div className="space-y-1">
              {Object.entries(countries).map(([key, country]) => (
                <button
                  key={key}
                  onClick={() => handleCountryChange(key)}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded transition-all duration-200 ${
                    activeCountry === key
                      ? 'bg-white text-[#434242] font-medium'
                      : 'text-gray-300 hover:bg-[#5a5a5a]'
                  }`}
                >
                  <span className="text-sm">{country.flag}</span>
                  <span className="text-xs font-medium">{country.name}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Document Types */}
          <div className="mb-4">
            <h1 className="text-sm font-semibold text-white mb-2">Document Types</h1>
            <div className="space-y-1">
              {Object.entries(currentDocuments).map(([key, doc]) => {
                const IconComponent = doc.icon;
                return (
                  <button
                    key={key}
                    onClick={() => {
                      setActiveTab(key);
                      setFile(null);
                      setPreview(null);
                      setResult(null);
                      setEditableData({});
                    }}
                    className={`w-full flex items-center gap-2 px-3 py-2 rounded transition-all duration-200 ${
                      activeTab === key
                        ? 'bg-[#0066cc] text-white font-medium'
                        : 'text-gray-300 hover:bg-[#5a5a5a]'
                    }`}
                  >
                    <IconComponent className="w-4 h-4 flex-shrink-0" />
                    <span className="text-xs font-medium text-left leading-tight">{doc.name}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Flow Diagram */}
          <div className="mt-3 pt-3 border-t border-[#5a5a5a]">
            <h3 className="text-xs font-semibold text-white mb-2">Process Flow</h3>
            <div className="space-y-1.5">
              <div className="flex items-center gap-1.5">
                <div className="w-5 h-5 rounded-full bg-[#0066cc] flex items-center justify-center text-xs font-bold text-white">1</div>
                <span className="text-xs text-gray-300">Select Document Type</span>
              </div>
              <div className="ml-2.5 w-px h-3 bg-[#5a5a5a]"></div>
              <div className="flex items-center gap-1.5">
                <div className="w-5 h-5 rounded-full bg-[#0066cc] flex items-center justify-center text-xs font-bold text-white">2</div>
                <span className="text-xs text-gray-300">Upload Document</span>
              </div>
              <div className="ml-2.5 w-px h-3 bg-[#5a5a5a]"></div>
              <div className="flex items-center gap-1.5">
                <div className="w-5 h-5 rounded-full bg-[#0066cc] flex items-center justify-center text-xs font-bold text-white">3</div>
                <span className="text-xs text-gray-300">Extract Data</span>
              </div>
              <div className="ml-2.5 w-px h-3 bg-[#5a5a5a]"></div>
              <div className="flex items-center gap-1.5">
                <div className="w-5 h-5 rounded-full bg-[#0066cc] flex items-center justify-center text-xs font-bold text-white">4</div>
                <span className="text-xs text-gray-300">Review & Export</span>
              </div>
            </div>
          </div>
        </aside>

        {/* Main Content Area */}
        <main className="flex-1 p-2">
          <div className="bg-white rounded-lg shadow-sm border border-[#e1e8ed] h-[calc(100vh+20px)]">
            <div className="p-2 border-b border-[#e1e8ed]">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-sm font-semibold text-blue-900">
                    {countries[activeCountry].flag} {countries[activeCountry].name} - {currentDocuments[activeTab]?.name} - Extracted Data
                  </h2>
                  <p className="text-xs text-blue-900">
                    Review and edit the extracted information below
                  </p>
                </div>
                {result && !result.error && (
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2 px-3 py-2 bg-[#28a745] rounded-lg shadow-sm">
                      <FiCheck className="w-4 h-4 text-white" />
                      <span className="text-sm font-medium text-white">
                        {result.confidence ? result.confidence.toFixed(1) : '0.0'}% Confidence
                      </span>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={exportJSON}
                        className="flex items-center gap-2 bg-[#0066cc] text-white px-3 py-2 rounded-lg hover:bg-[#0052a3] transition-all duration-200 text-xs shadow-sm"
                      >
                        <FiDownload className="w-3 h-3" />
                        JSON
                      </button>
                      <button
                        onClick={exportTXT}
                        className="flex items-center gap-2 bg-[#0066cc] text-white px-3 py-2 rounded-lg hover:bg-[#0052a3] transition-all duration-200 text-xs shadow-sm"
                      >
                        <FiDownload className="w-3 h-3" />
                        TXT
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="p-3 h-[calc(100vh-40px)] overflow-hidden">
              <div className="bg-[#fafbfc] rounded-lg border border-[#e1e8ed] h-full overflow-hidden shadow-sm">
                <div className="p-4 h-full overflow-y-auto scrollbar-hide">
                  <div className="space-y-4 h-full">
                    {/* Upload Section - Full Width */}
                    <div className="w-full">
                      <h3 className="text-sm font-semibold text-blue-800 mb-2">Upload Document</h3>
                      
                      <div
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                        className="border-2 border-dashed border-[#ced4da] rounded-lg p-3 text-center hover:border-[#0066cc] hover:bg-[#f8f9fa] transition-all duration-200 bg-white"
                      >
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png,.pdf"
                          onChange={handleFileChange}
                          className="hidden"
                          id="file-upload"
                        />
                        <label htmlFor="file-upload" className="cursor-pointer">
                          <div className="text-[#495057]">
                            <FiUploadCloud className="mx-auto h-8 w-8 mb-2 text-[#0066cc]" />
                            <p className="text-sm font-medium mb-1">Drop file here or click</p>
                            <p className="text-sm">JPG, PNG, PDF up to 16MB</p>
                          </div>
                        </label>
                      </div>

                      {/* Extract Button */}
                      <button
                        onClick={extractData}
                        disabled={!file || loading}
                        className="w-full mt-3 bg-[#0066cc] text-white py-3 px-4 rounded-lg hover:bg-[#0052a3] disabled:bg-[#ced4da] disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium flex items-center justify-center gap-2 shadow-sm"
                      >
                        {loading ? (
                          <>
                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                            Processing...
                          </>
                        ) : (
                          <>
                            <FiZap className="w-4 h-4" />
                            Extract Data
                          </>
                        )}
                      </button>
                    </div>

                    {/* Raw Text Section for Non-India Countries */}
                    {activeCountry !== 'india' && result && result.raw_text && (
                      <div className="w-full">
                        <h3 className="text-sm font-semibold text-blue-800 mb-2">Raw OCR Text (for verification)</h3>
                        <div className="bg-gray-50 p-3 rounded-lg border max-h-40 overflow-y-auto">
                          <pre className="text-xs text-gray-700 whitespace-pre-wrap font-mono">
                            {result.raw_text}
                          </pre>
                        </div>
                      </div>
                    )}

                    {/* GST Verification Section */}
                    {activeTab === 'gst' && editableData?.gstin && (
                      <VerificationDashboard 
                        extractedData={editableData}
                        onVerify={verifyGSTData}
                      />
                    )}

                    {/* PAN Verification Section */}
                    {activeTab === 'pan' && editableData?.pan_number && (
                      <PANVerificationDashboard 
                        extractedData={editableData}
                        onVerify={verifyPANData}
                      />
                    )}

                    {/* CIN Verification Section */}
                    {activeTab === 'coi' && editableData?.cin && (
                      <CINVerificationDashboard 
                        extractedData={editableData}
                        onVerify={verifyCINData}
                      />
                    )}

                    {/* Bank Verification Section */}
                    {activeTab === 'cheque' && editableData?.account_number && editableData?.ifsc_code && (
                      <BankVerificationDashboard 
                        extractedData={editableData}
                        onVerify={verifyBankData}
                      />
                    )}

                    {/* MSME Verification Section */}
                    {activeTab === 'msme' && editableData?.registration_number && (
                      <MSMEVerificationDashboard 
                        extractedData={editableData}
                        onVerify={verifyMSMEData}
                      />
                    )}

                    {/* Fields and Preview Section - Side by Side */}
                    <div className="flex gap-6 flex-1">
                      {/* Left Side - Fields */}
                      <div className="w-1/2">
                        {result?.error ? (
                          <div className="flex items-center gap-2 text-red-600 p-2 bg-red-50 rounded-lg border border-red-200 mb-4">
                            <FiAlertTriangle className="w-4 h-4" />
                            <span className="text-sm">Error: {result.error}</span>
                          </div>
                        ) : null}
                        
                        <div className="space-y-3">
                          {currentDocuments[activeTab]?.fields.map(field => {
                            const fieldConf = result?.field_confidence?.[field];
                            const needsReview = fieldConf?.needs_review;
                            const confidence = fieldConf?.confidence || 100;
                            
                            const getFieldLabel = (field) => {
                              // Check if it's a company PAN (4th character is 'C')
                              const panNumber = editableData?.pan_number || '';
                              const isCompanyPAN = panNumber.length >= 4 && panNumber[3].toUpperCase() === 'C';
                              
                              const labels = {
                                'father_name': 'FATHER NAME',
                                'date_of_birth': isCompanyPAN ? 'DATE OF INCORPORATION' : 'DATE OF BIRTH',
                                'name': isCompanyPAN ? 'ENTITY NAME' : 'NAME',
                                'registration_number': 'REGISTRATION NUMBER',
                                'business_name': 'BUSINESS NAME',
                                'enterprise_type': 'TYPE OF ENTERPRISE',
                                'registration_date': activeTab === 'msme' ? 'DATE OF UDYAM REGISTRATION' : 'DATE OF REGISTRATION',
                                'incorporation_date': 'DATE OF INCORPORATION',
                                'flat_no': 'FLAT/DOOR/BLOCK NO.',
                                'building': 'NAME OF BUILDING',
                                'village': 'VILLAGE/TOWN',
                                'block': 'BLOCK',
                                'road': 'ROAD STREET LANE',
                                'mobile': 'MOBILE',
                                'email': 'EMAIL',
                                'certificate_number': 'CERTIFICATE NUMBER',
                                'certificate_date': 'CERTIFICATE DATE',
                                'validity_date': 'VALIDITY DATE',
                                'postal_code': 'POSTAL CODE',
                                'act_reference': 'ACT REFERENCE',
                                'business_number': 'BUSINESS NUMBER',
                                'owner_name': 'OWNER NAME',
                                'po_box': 'P.O BOX',
                                'district': 'DISTRICT',
                                'company_name': 'COMPANY NAME',
                                'rc_number': 'RC NUMBER',
                                'tin_number': 'TIN NUMBER',
                                'pin_number': 'PIN NUMBER',
                                'legal_representative': 'LEGAL REPRESENTATIVE',
                                'business_scope': 'BUSINESS SCOPE',
                                'registered_capital': 'REGISTERED CAPITAL',
                                'registered_office': 'REGISTERED OFFICE',
                                'postal_address': 'POSTAL ADDRESS',
                                'vendor_name': 'VENDOR NAME',
                                'vendor_type': 'VENDOR TYPE',
                                'vendor_category': 'VENDOR CATEGORY',
                                'tax_office': 'TAX OFFICE',
                                'compliance_period': 'COMPLIANCE PERIOD',
                                'directors': 'DIRECTORS',
                                'share_capital': 'SHARE CAPITAL',
                                'issue_date': 'ISSUE DATE',
                                'tcc_number': 'TCC NUMBER',
                                'firs_id': 'FIRS ID',
                                'business_address': 'BUSINESS ADDRESS',
                                'business_status': 'BUSINESS STATUS',
                                'expiry_date': 'EXPIRY DATE'
                              };
                              return labels[field] || field.replace(/_/g, ' ').toUpperCase();
                            };
                            
                            const getFieldBg = () => {
                              return 'bg-[#C2CFF5]';
                            };
                            
                            return (
                              <div key={field} className="space-y-1">
                                <label className="block text-xs font-medium text-blue-800">
                                  {getFieldLabel(field)}
                                  {needsReview && (
                                    <span className="ml-1 inline-flex items-center gap-1 text-xs text-orange-700 bg-orange-100 px-1 py-0.5 rounded-full">
                                      <FiAlertTriangle className="w-2 h-2" />
                                      Review ({confidence}%)
                                    </span>
                                  )}
                                </label>
                                {field === 'address' || field === 'business_scope' || field === 'directors' || field === 'registered_office' || field === 'postal_address' || field === 'business_address' ? (
                                  <textarea
                                    value={(editableData && editableData[field]) || ''}
                                    onChange={(e) => handleFieldEdit(field, e.target.value)}
                                    rows={3}
                                    className={`w-full p-2 text-sm border-2 rounded-lg backdrop-blur-sm border-white focus:ring-2 focus:ring-white focus:border-white transition-all duration-200 shadow-lg text-blue-900 font-semibold placeholder-white resize-none ${
                                      needsReview 
                                        ? 'border-orange-300 bg-orange-400/80' 
                                        : `hover:border-white ${getFieldBg()}`
                                    }`}
                                    placeholder={`Enter ${getFieldLabel(field).toLowerCase()}`}
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    value={(editableData && editableData[field]) || ''}
                                    onChange={(e) => handleFieldEdit(field, e.target.value)}
                                    className={`w-full p-2 text-sm border-2 rounded-lg backdrop-blur-sm border-white focus:ring-2 focus:ring-white focus:border-white transition-all duration-200 shadow-lg text-blue-900 font-semibold placeholder-white ${
                                      needsReview 
                                        ? 'border-orange-300 bg-orange-400/80' 
                                        : `hover:border-white ${getFieldBg()}`
                                    }`}
                                    placeholder={`Enter ${getFieldLabel(field).toLowerCase()}`}
                                  />
                                )}
                                {needsReview && fieldConf?.reason && (
                                  <p className="text-xs text-orange-600 flex items-center gap-1">
                                    <FiAlertTriangle className="w-2 h-2" />
                                    {fieldConf.reason}
                                  </p>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/* Right Side - Document Preview */}
                      <div className="w-1/2">
                        {preview && (
                          <div className="space-y-2">
                            <h4 className="text-sm font-semibold text-blue-800">Document Preview</h4>
                            {file?.type === 'application/pdf' ? (
                              <div className="bg-gray-50 p-2 rounded border">
                                <div className="flex items-center gap-1 mb-1">
                                  <FiFile className="w-3 h-3 text-red-500" />
                                  <p className="text-xs text-gray-600 font-medium truncate">{file.name}</p>
                                </div>
                                <iframe 
                                  src={preview} 
                                  className="w-full h-96 rounded border scrollbar-hide" 
                                  title="PDF Preview"
                                  style={{overflow: 'hidden'}}
                                />
                              </div>
                            ) : (
                              <div className="bg-gray-50 p-2 rounded border">
                                <img src={preview} alt="Preview" className="w-full h-96 object-contain rounded" />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default DocumentExtractor;